import { Button } from "src/primitives/Button";

import type { BulkSelectAllRowsProps } from "../types";

interface BulkSelectCalloutProps {
  bulkSelectAllRowsProps: BulkSelectAllRowsProps;
  isAllPageRowsSelected: boolean;
  isBulkAllSelected: boolean;
  onBulkSelectAll: () => void;
  onClearBulkSelection: () => void;
}

export const BulkSelectCallout = ({
  bulkSelectAllRowsProps,
  isAllPageRowsSelected,
  isBulkAllSelected,
  onBulkSelectAll,
  onClearBulkSelection,
}: BulkSelectCalloutProps) => {
  if (!isAllPageRowsSelected && !isBulkAllSelected) return null;

  const {
    selectAllRowMessage,
    selectAllRowButtonLabel,
    allRowsSelectedMessage,
    clearSelectionButtonLabel,
  } = bulkSelectAllRowsProps;

  return (
    <div className="mb-2 flex items-center justify-center gap-1 rounded-sm bg-primary/10 px-4 py-1.5 text-sm text-primary">
      {isBulkAllSelected ? (
        <>
          <span>{allRowsSelectedMessage ?? selectAllRowMessage}</span>
          <Button variant="link" onClick={onClearBulkSelection}>
            {clearSelectionButtonLabel ?? "Clear selection"}
          </Button>
        </>
      ) : (
        <>
          <span>{selectAllRowMessage}</span>
          <Button variant="link" onClick={onBulkSelectAll}>
            {selectAllRowButtonLabel}
          </Button>
        </>
      )}
    </div>
  );
};
